export default function RejectedIcon({ width, height }) {
  return (
    <svg width="66" height="66" viewBox="0 0 66 66" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="5" y="5" width="56" height="56" rx="28" fill="#FEE4E2" />
      <path d="M24.7513 24.7516L41.248 41.2483M44.6663 32.9999C44.6663 39.4432 39.443 44.6666 32.9997 44.6666C26.5564 44.6666 21.333 39.4432 21.333 32.9999C21.333 26.5566 26.5564 21.3333 32.9997 21.3333C39.443 21.3333 44.6663 26.5566 44.6663 32.9999Z" stroke="#D92D20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      <rect x="5" y="5" width="56" height="56" rx="28" stroke="#FEF3F2" stroke-width="10" />
    </svg>

  );
}
